import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '../types';
import { api } from '../services/api';

interface AuthState {
  user: User | null;
  token: string | null;
  isLoading: boolean;
  signUp: (email: string, password: string) => Promise<void>;
  signIn: (email: string, password: string) => Promise<void>;
  signInWithToken: (token: string) => Promise<void>;
  signUpWithGoogle: () => Promise<void>;
  signInWithGoogle: () => Promise<void>;
  signOut: () => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: true,

      signUp: async (email, password) => {
        try {
          const response = await api.post('/auth/signup', { email, password });
          set({ user: response.user, token: response.token });
        } catch (error) {
          throw error;
        }
      },

      signIn: async (email, password) => {
        try {
          const response = await api.post('/auth/signin', { email, password });
          set({ user: response.user, token: response.token });
        } catch (error) {
          throw error;
        }
      },

      signInWithToken: async (token) => {
        try {
          // Verify the token by getting user info
          const response = await api.get('/auth/me');
          set({ user: response.user, token });
        } catch (error) {
          console.error('Invalid token:', error);
          set({ token: null, user: null });
        }
      },

      signUpWithGoogle: async () => {
        try {
          window.location.href = '/api/auth/google';
        } catch (error) {
          throw error;
        }
      },

      signInWithGoogle: async () => {
        try {
          window.location.href = '/api/auth/google';
        } catch (error) {
          throw error;
        }
      },

      signOut: () => {
        set({ user: null, token: null });
      },

      checkAuth: async () => {
        const { token } = get();
        if (!token) {
          set({ isLoading: false });
          return;
        }
        
        try {
          const response = await api.get('/auth/me');
          set({ user: response.user });
        } catch (error) {
          set({ token: null, user: null });
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ token: state.token }),
    }
  )
);
